/* @flow */

import React from 'react';

import Link from 'depop/components/Link';

import { FAMILY_STANDARD_BOLD } from 'depop/styles/typography';

import { style } from 'glamor';

type Props = {
  source: string,
};

const MentionToken = ({ source }: Props) =>
  <Link
    to={{
      pathname: `/${source.slice(1)}`,
    }}
    {...style({
      color: '#000',
      textDecoration: 'none',
      fontWeight: 'bold',
      fontFamily: FAMILY_STANDARD_BOLD,
      ':hover': {
        textDecoration: 'underline',
      },
    })}>
    {source}
  </Link>;

export default MentionToken;



// WEBPACK FOOTER //
// ../src/client/components/UserText/MentionToken.js